// ===== Pesos e volumes PDLED =====
// Fonte: "CALCULADORA DE PESO E VOLUMES PARA COTAÇÃO.xlsx" (aba CALCULADORA).
// Perfis e fitas são pesados por metro; fontes e presilhas por unidade.
// O peso bruto do pedido = peso dos itens + tara das caixas de embalagem.

// Perfis — kg por metro (kg por unidade quando o item é vendido por unidade)
const PESOS_PERFIL = [
  ["PDL01", 0.07], ["PDL02", 0.07], ["PDL11", 0.13], ["PDL12", 0.16], ["PDL13", 0.16],
  ["PDL14", 0.14], ["PDL21", 0.17], ["PDL22", 0.09], ["PDL32", 0.08], ["PDL41C", 1.15],
  ["PDL41", 0.62], ["PDL50", 0.33], ["PDL51", 0.6], ["PDL52", 0.75], ["PDL60", 0.2],
  ["PDL61", 0.55], ["PDL62", 0.69], ["PDL64", 0.2], ["PDL65", 0.85], ["PDL71", 0.485],
  ["PDL74", 1.27], ["PDL90", 0.43], ["PDL91", 0.32], ["PDL92", 0.6], ["PDL95", 0.13],
  ["PDL97", 0.5], ["PDL98", 0.57], ["PDL99", 0.88], ["PDL100", 0.38], ["PDL101", 0.26],
  ["PDL N 1212 PR-FLEX", 0.05], ["PDL N 0807", 0.06], ["PDL N 1212", 0.12],
  ["PDL N 1525", 0.3], ["PDL N 2014", 0.26], ["PDL MAGIC LINE", 0.5], ["PDLT5", 0.4],
  ["DECO", 1.28], ["ARANDELA TAUARI", 1.11], ["FITA METALIZA SKYLINE", 0.04], ["KIT SKYLINE", 0.36],
];

// Fitas de LED — kg por metro. tag distingue variantes de mesma potência.
const PESOS_FITA = [
  { nome: "3W IP20",            w: 3,    ip: 20, tag: "",        kg: 0.0168 },
  { nome: "3W IP67",            w: 3,    ip: 67, tag: "",        kg: 0.0425 },
  { nome: "4,8W IP65 / SAUNA",  w: 4.8,  ip: 67, tag: "SAUNA",   kg: 0.0568 },
  { nome: "5W IP20 BABY",       w: 5,    ip: 20, tag: "BABY",    kg: 0.0138 },
  { nome: "10W IP20 BABY",      w: 10,   ip: 20, tag: "BABY",    kg: 0.0112 },
  { nome: "10W IP20 COB",       w: 10,   ip: 20, tag: "COB",     kg: 0.0174 },
  { nome: "5W IP20",            w: 5,    ip: 20, tag: "",        kg: 0.0136 },
  { nome: "5W IP67",            w: 5,    ip: 67, tag: "",        kg: 0.036 },
  { nome: "10W IP20",           w: 10,   ip: 20, tag: "",        kg: 0.0168 },
  { nome: "10W IP67",           w: 10,   ip: 67, tag: "",        kg: 0.0433 },
  { nome: "14,4W IP20",         w: 14.4, ip: 20, tag: "",        kg: 0.0234 },
  { nome: "14,4W IP67",         w: 14.4, ip: 67, tag: "",        kg: 0.0736 },
  { nome: "14,4W DIGITAL",      w: 14.4, ip: 0,  tag: "DIGITAL", kg: 0.0422 },
  { nome: "19,2W RGBW",         w: 19.2, ip: 0,  tag: "RGBW",    kg: 0.0594 },
  { nome: "19,2W IP20",         w: 19.2, ip: 20, tag: "",        kg: 0.0192 },
  { nome: "19,2W IP67",         w: 19.2, ip: 67, tag: "",        kg: 0.0916 },
  { nome: "24W IP20",           w: 24,   ip: 20, tag: "",        kg: 0.0216 },
  { nome: "24W IP67",           w: 24,   ip: 67, tag: "",        kg: 0.05 },
  { nome: "5W IP67 UL",         w: 5,    ip: 67, tag: "UL",      kg: 0.067 },
  { nome: "10W IP67 UL",        w: 10,   ip: 67, tag: "UL",      kg: 0.07 },
];

/**
 * Fitas IP65, derivadas — regra do Kaio, 18/09/2026.
 *
 *   IP65 = IP20 + 40% da diferenca (IP67 - IP20)
 *
 * A planilha nao traz IP65 comum: so a SAUNA e a RGBW, que sao especiais. Sem
 * isto, 31 produtos IP65 ficavam sem peso -- o maior buraco isolado do catalogo
 * de fitas. Com a regra, a cobertura vai de 65,6% para 85,5%.
 *
 * Faz sentido fisico: IP65 leva silicone so na face superior, entao pesa entre a
 * IP20 (sem capa) e a IP67 (encapsulada). Os 40% sao a proporcao que o Kaio
 * informou, nao uma media que eu tenha inventado.
 *
 * SO DERIVA QUANDO EXISTEM OS DOIS EXTREMOS, e com a MESMA tag. Potencia que so
 * tem um dos lados fica de fora e o item volta em `sem` -- estimar a partir de
 * um extremo so seria inventar.
 *
 * As variantes com tecnologia propria (COB, BABY, DIGITAL, RGBW, UL) nao entram:
 * o peso delas nao segue a mesma proporcao de encapsulamento.
 */
const derivarIP65 = (base) => {
  const porChave = {};
  for (const f of base) {
    if (f.tag) continue;                       // so as variantes simples
    (porChave[f.w] ||= {})[f.ip] = f.kg;
  }
  const saida = [];
  for (const [w, ips] of Object.entries(porChave)) {
    if (ips[20] == null || ips[67] == null || ips[65] != null) continue;
    saida.push({
      nome: `${String(w).replace(".", ",")}W IP65 (derivada)`,
      w: Number(w), ip: 65, tag: "", derivada: true,
      kg: Number((ips[20] + 0.4 * (ips[67] - ips[20])).toFixed(4)),
    });
  }
  return saida;
};

const PESOS_FITA_IP65 = derivarIP65(PESOS_FITA);
PESOS_FITA.push(...PESOS_FITA_IP65);

// Fontes e drivers — kg por unidade, por código PDLED
const PESOS_FONTE = [
  ["PDL SL1824", 0.03], ["PDL SL2424", 0.04], ["PDL SL3624", 0.08], ["PDL SL6024", 0.1],
  ["PDL SL10024", 0.2], ["PDL SF10024", 0.2], ["PDL CH3524", 0.2], ["PDL CH7524", 0.24],
  ["PDL CH10024", 0.3], ["PDL CH15024", 0.38], ["PDL CH25024", 0.58], ["PDL CH30024", 0.68],
  ["PDL CH35024", 0.68], ["PDL BL3024", 0.24], ["PDL BL6024", 0.3], ["PDL BL10024", 0.9],
  ["PDL BL15024", 0.68], ["PDL BL20024", 0.56], ["PDL BL30024", 1.14],
  ["PDL DIM60/24-110", 0.22], ["PDL DIM100/24-110", 0.3],
  ["PDL SL BL3624", 0.14], ["PDL SL BL6024", 0.16], ["PDL DALI100/24-110", 0.3],
  // A versao 220V pesa o mesmo que a 110V (Kaio, 21/09). Sem estas duas linhas o
  // codigo cai no startsWith de "PDL DIM60/24-1" e nao casa com o sufixo 220.
  ["PDL DIM60/24-220", 0.22], ["PDL DIM100/24-220", 0.3],
];

// Itens avulsos que nao sao perfil, fita nem fonte -- kg por UNIDADE.
const PESOS_AVULSOS = [
  // Bisnaga de silicone, 10 g (Kaio, 21/09). E o item mais frequente dos que
  // estavam sem peso: 43 de 180 ocorrencias em pedido real.
  ["PDL-FS10010", 0.010],
];

const PESO_PRESILHA_KG = 0.003; // par de presilhas

// Caixas de embalagem — tara em kg e medidas em metros (L x A x C)
//
// `dim` repete as `medidas` em numero. Existe porque a cotacao de frete precisa
// do VOLUME em m3 (campo `metragemCubica` da Jamef), e extrair isso do texto por
// expressao regular quebraria no dia em que alguem trocasse a virgula por ponto.
// O teste `caixas-batem-com-as-medidas` compara os dois e falha se divergirem.
const CAIXAS_EMBALAGEM = [
  { nome: "1M",                 tara: 0.67, medidas: "0,15 x 0,20 x 1,25", dim: [0.15, 0.20, 1.25], compMax: 1 },
  { nome: "2M",                 tara: 1.33, medidas: "0,15 x 0,20 x 2,25", dim: [0.15, 0.20, 2.25], compMax: 2 },
  { nome: "3M",                 tara: 2.00, medidas: "0,15 x 0,20 x 3,25", dim: [0.15, 0.20, 3.25], compMax: 3 },
  { nome: "CAIXA QUADRADA",     tara: 1.60, medidas: "0,50 x 0,33 x 0,47", dim: [0.50, 0.33, 0.47], compMax: 0.5 },
  { nome: "CAIXA DE AMOSTRA 1", tara: 0.22, medidas: "0,09 x 0,31 x 0,38", dim: [0.09, 0.31, 0.38], compMax: 0.38 },
  { nome: "CAIXA DE AMOSTRA 2", tara: 0.16, medidas: "0,10 x 0,24 x 0,31", dim: [0.10, 0.24, 0.31], compMax: 0.31 },
];
const CAIXA_BY_NOME = Object.fromEntries(CAIXAS_EMBALAGEM.map(c => [c.nome, c]));

// ─── Resolução do peso de um item ─────────────────────────────────────────────
const normPeso = (s) => String(s || "").toUpperCase()
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[\s._]/g, "");

const PERFIL_KEYS = PESOS_PERFIL
  .map(([k, kg]) => ({ k, n: normPeso(k), kg }))
  .sort((a, b) => b.n.length - a.n.length);
const AVULSO_KEYS = PESOS_AVULSOS
  .map(([k, kg]) => ({ k, n: normPeso(k), kg }))
  .sort((a, b) => b.n.length - a.n.length);
const FONTE_KEYS = PESOS_FONTE
  .map(([k, kg]) => ({ k, n: normPeso(k), kg }))
  .sort((a, b) => b.n.length - a.n.length);

/**
 * Potência e grau IP a partir do CÓDIGO do produto.
 *
 * O código de fita é POSICIONAL e não escreve "W" nem "IP" -- por isso a leitura
 * por texto nunca casava com ele, e as fitas ficavam sem peso: ZERO de 131,
 * medido em 17/09. Dois formatos convivem no catálogo:
 *
 *   PDL-FL-[prefixo-]POT/COR/IP/V[/IRC]       ex.: PDL-FL-10/27/65/24/90
 *   PDL-FL-<largura>MM[-COB]/POT/COR/IP/...   ex.: PDL-FL-4MM/3/30/65/24/90
 *
 * O IP é achado pelo VALOR, não pela posição: o conjunto é fechado, e procurar
 * por posição confunde `27` (2700 K) com grau de proteção.
 */
function fitaPeloCodigo(codigo) {
  const cru = String(codigo || "").trim().toUpperCase();
  // Serve tambem a PERFIL COM FITA INTEGRADA, nao so a fita pura. O formato e o
  // mesmo depois do prefixo -- `PDL90-20/27/67/24/90` e um PDL90 com fita de
  // 20 W (que sao duas de 10, ver fitaDupla) e `PDL-FL-10/27/65/24/90` e a fita
  // sozinha. Exigir `PDL-FL-` deixava todo perfil com fita sem peso de fita.
  if (!/\//.test(cru)) return null;
  const partes = cru.replace(/^PDL-FL-/, "").split("/");
  const comLargura = /^\d+\s*MM/.test(partes[0]);
  const alvo = comLargura ? partes[1] : partes[0];
  // A potencia e o ultimo numero da primeira parte: em `PDL90-20` e o 20, em
  // `PDL6010-UL-7,5` e o 7,5. Aceita decimal com virgula, que o codigo usa.
  const w = (/([\d,]+)\s*$/.exec(String(alvo || "")) || [])[1]?.replace(",", ".");
  const ip = partes.find(x => ["20", "54", "55", "65", "66", "67", "68"].includes(x.trim()));
  if (!w || !ip) return null;
  const tag = ["SAUNA", "BABY", "COB", "DIGITAL", "RGBW", "UL"].find(x => cru.includes(x)) || "";
  return { w: Number(w), ip: Number(ip), tag };
}

/**
 * Fita a partir do código ou da descrição.
 *
 * Tenta primeiro o código posicional, que é o dado confiável; só depois cai para
 * a leitura do texto, que serve para itens descritos à mão.
 *
 * O GRAU IP É COMPARADO EXATO. A versão anterior fazia
 * `ip === "20" ? 20 : ip ? 67 : 0` -- qualquer grau diferente de 20 virava 67.
 * Isso passava despercebido enquanto a tabela só tinha IP20 e IP67; agora que há
 * IP65 derivada, colapsar daria o peso da encapsulada, que é bem mais pesada
 * (10W: 0,0433 contra 0,0274). O item ficaria 58% mais pesado do que é.
 */
function acharFita(texto, codigo) {
  const doCodigo = fitaPeloCodigo(codigo);
  let w, ip, tag;
  if (doCodigo) {
    ({ w, ip, tag } = doCodigo);
  } else {
    const t = normPeso(texto);
    const mw = t.match(/(\d{1,2}(?:,\d)?)W/);
    if (!mw) return null;
    w = parseFloat(mw[1].replace(",", "."));
    ip = Number((t.match(/IP(\d{2})/) || [])[1]) || 0;
    tag = ["SAUNA", "BABY", "COB", "DIGITAL", "RGBW", "UL"].find(x => t.includes(x)) || "";
  }
  // O CODIGO TRUNCA A POTENCIA. `PDL-FL-14/30/20/24/90` e a fita de 14,4 W;
  // `19/27/65` e a de 19,2 W. Comparar so por igualdade exata deixava essas de
  // fora -- e sao justamente as potencias quebradas da planilha.
  const casaPotencia = (f) => Math.abs(f.w - w) < 0.05 || Math.floor(f.w) === w;
  const cands = PESOS_FITA.filter(casaPotencia);
  const achou = cands.find(f => f.tag === tag && f.ip === ip)
      || cands.find(f => f.tag === tag && !f.ip)
      || cands.find(f => f.ip === ip && !f.tag);
  if (achou) return achou;
  // Sem grau compatível NÃO se chuta o primeiro candidato: peso errado é pior
  // que nenhum. Mas antes de desistir, há uma hipótese a testar.
  return fitaDupla(w, ip, tag);
}

/**
 * FITA DUPLA: a potência do código pode ser a SOMA de duas fitas.
 *
 * Regra do Kaio (21/09), com dois exemplos dele:
 *   PDL90-20/27/67/24/90             -> PDL90 com DUAS fitas de 10W
 *   PDL DECO PRIS PEN DI - 29/40/20  -> DECO com uma de 10W e uma de 19W
 *
 * O `29` denuncia a coisa: não existe fita de 29 W, e 10 + 19 existe. Perfil com
 * dois canais de LED soma a potência no código, e quem lê a potência como uma
 * fita só não acha nada -- era o que acontecia.
 *
 * Procura um par do MESMO grau IP e variante cuja soma bata. Prefere duas fitas
 * IGUAIS, que é o caso comum; só então tenta fitas diferentes, e aí fica com o
 * par mais equilibrado -- 29 W tem uma decomposição natural (10+19) e várias
 * forçadas.
 */
function fitaDupla(w, ip, tag) {
  const mesmas = PESOS_FITA.filter(f => f.tag === tag && f.ip === ip);
  if (!mesmas.length) return null;

  // Mesma tolerancia ao truncamento: duas fitas de 19,2 W aparecem como 38 no
  // codigo, nao 38,4.
  const perto = (a, b) => Math.abs(a - b) < 0.05 || Math.floor(a) === Math.floor(b);
  const meia = mesmas.find(f => perto(f.w * 2, w));
  if (meia) return { nome: `2x ${meia.nome}`, w, ip, tag, kg: meia.kg * 2, dupla: true };

  let melhor = null;
  for (const a of mesmas) {
    for (const b of mesmas) {
      if (!perto(a.w + b.w, w)) continue;
      const desequilibrio = Math.abs(a.w - b.w);
      if (!melhor || desequilibrio < melhor.desequilibrio) {
        melhor = { desequilibrio, nome: `${a.nome} + ${b.nome}`, kg: a.kg + b.kg };
      }
    }
  }
  return melhor ? { nome: melhor.nome, w, ip, tag, kg: melhor.kg, dupla: true } : null;
}

// Peso unitário estimado de um item da proposta (kg por metro ou por unidade).
// Retorna { kg, origem, detalhe } ou null quando não há peso cadastrado.
function pesoUnitarioItem(item) {
  const cod  = normPeso(item.codigo);
  const desc = `${item.codigo || ""} ${item.nome || ""} ${item.descricaoEstendida || ""}`;
  if (!cod && !item.nome) return null;

  const avulso = AVULSO_KEYS.find(x => cod.startsWith(x.n));
  if (avulso) return { kg: avulso.kg, origem: "avulso", detalhe: avulso.k };

  const fonte = FONTE_KEYS.find(f => cod.startsWith(f.n) || cod === f.n);
  if (fonte) return { kg: fonte.kg, origem: "fonte", detalhe: fonte.k };

  // SKYLINE -- codigo 0684, decodificado pelo Kaio em 21/09.
  //
  //   PDL SF0684/BR              -> so a fita metalica (por METRO)
  //   PDL0684-PO/BR              -> so o kit (por unidade)
  //   PDL4M0684-I-14/27/20/PT    -> acabado de 4 m, indireto, com fita 14W
  //   PDL8M0684-SF/PT            -> acabado de 8 m SEM fita de led
  //
  // O acabado e a soma de tres coisas que a planilha ja tem separadas: o kit, a
  // fita metalica pela metragem, e a fita de led pela mesma metragem. Sao 1.070
  // produtos no catalogo -- praticamente todo o Skyline.
  //
  // Vem ANTES da regra SF generica de proposito: `PDLSF0684` casaria com ela e
  // procuraria um perfil "PDL0684" que nao existe.
  if (/0684/.test(cod)) {
    const metalica = PESOS_PERFIL.find(([k]) => /METALI/i.test(normPeso(k)));
    const kit = PESOS_PERFIL.find(([k]) => /KITSKYLINE/i.test(normPeso(k)));
    if (/^PDLSF0684/.test(cod) && metalica) {
      return { kg: metalica[1], origem: "skyline", detalhe: "fita metalica (por metro)" };
    }
    if (/^PDL0684-PO/.test(cod) && kit) {
      return { kg: kit[1], origem: "skyline", detalhe: "kit" };
    }
    const acabado = /^PDL(\d+)M0684/.exec(cod);
    if (acabado && kit && metalica) {
      const metros = Number(acabado[1]);
      // `-SF` aqui significa SEM FITA, o mesmo que na linha SF de perfil.
      const semFita = /-SF(?:\/|$)/.test(cod);
      const fitaLed = semFita ? null : acharFita(desc, item.codigo);
      const kg = kit[1] + metalica[1] * metros + (fitaLed ? fitaLed.kg * metros : 0);
      // Acabado COM fita cujo modelo nao se reconhece fica pendente: somar so o
      // kit e a metalica daria um peso menor que o real, com cara de calculado.
      if (!semFita && !fitaLed) return null;
      return {
        kg: Math.round(kg * 1000) / 1000,
        origem: "skyline",
        detalhe: `kit + metalica x${metros}m${fitaLed ? ` + ${fitaLed.nome} x${metros}m` : " (sem fita)"}`,
      };
    }
  }

  // LINHA SF -- perfil SEM fita, com a metragem no proprio codigo e vendido por
  // UNIDADE (Kaio, 21/09). `PDL SF1210-2M-BR` e um perfil PDL12 de 2 metros na
  // cor branca, com difusor, presilha e endcap -- que ja estao embutidos no peso
  // por metro da planilha.
  //
  // Sem esta regra o codigo nao casa com nada: "PDLSF1210" nao comeca com
  // "PDL12", e o item ficava sem peso. Sao 37 das 180 ocorrencias.
  const sf = /^PDLSF(\d{3,5})/.exec(cod);
  if (sf) {
    const familia = PERFIL_KEYS.find(p => ("PDL" + sf[1]).startsWith(p.n));
    const metros = Number((/-(\d+(?:[.,]\d+)?)M(?:-|$)/.exec(cod) || [])[1]?.replace(",", "."));
    if (familia && metros > 0) {
      // O peso da planilha e por METRO; aqui devolvemos o peso da PECA, porque a
      // linha SF e vendida por unidade. Multiplicar e o ponto da regra.
      return { kg: Math.round(familia.kg * metros * 1000) / 1000, origem: "perfil SF", detalhe: `${familia.k} x ${metros}m` };
    }
  }

  if (/PRESILHA/.test(normPeso(desc))) return { kg: PESO_PRESILHA_KG, origem: "presilha", detalhe: "par" };

  // `cod.startsWith(p.n)` sozinho perde os perfis cujo NOME na planilha nao
  // comeca com PDL -- "Deco", "Arandela Tauari" -- mas cujo codigo de produto
  // comeca: `PDLDECOPRISPENDI...`. Sem o segundo teste, o Deco ficava sem peso.
  const perfil = PERFIL_KEYS.find(p => cod.startsWith(p.n) || cod.startsWith("PDL" + p.n));
  const fita   = acharFita(desc, item.codigo);
  // Perfil com fita integrada (ex.: PDL N 201420 - 10w/2700k/IP65) soma os dois
  if (perfil && fita && !/-(EC|DIF|PR)\b/i.test(item.codigo || ""))
    return { kg: perfil.kg + fita.kg, origem: "perfil+fita", detalhe: `${perfil.k} + ${fita.nome}` };
  if (perfil) return { kg: perfil.kg, origem: "perfil", detalhe: perfil.k };

  // PERFIL DESCONHECIDO COM FITA CONHECIDA devolve NADA, nao a fita sozinha.
  // `PDL10530-19/27/20/PT` e o perfil PDL105 (fora da planilha) com uma fita de
  // 19 W: a fita pesa 0,019 kg/m e o perfil, uns 0,3. Devolver so a fita daria
  // um peso 15x menor -- e um frete subestimado com cara de calculado e pior que
  // um item marcado como pendente.
  //
  // O que distingue os dois casos e o prefixo: fita pura e `PDL-FL-...`; perfil
  // e `PDL<familia><variante>-...`.
  const parecePerfil = /^PDL\d{3,5}[-/]/.test(cod);
  if (fita && !parecePerfil) return { kg: fita.kg, origem: "fita", detalhe: fita.nome };
  return null;
}

// Peso líquido do conjunto de itens + o que ficou sem peso cadastrado
function pesoLiquidoItens(itens) {
  let kg = 0; const sem = []; const por = {};
  for (const it of itens || []) {
    const p = pesoUnitarioItem(it);
    const q = Number(it.quantidade) || 0;
    if (!p) { sem.push(it); continue; }
    kg += p.kg * q;
    por[p.origem] = (por[p.origem] || 0) + p.kg * q;
  }
  return { kg: Math.round(kg * 1000) / 1000, sem, por };
}

const kgFmt = (n) => (Math.round((Number(n) || 0) * 1000) / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 3 });

export {
  PESOS_PERFIL, PESOS_FITA, PESOS_FITA_IP65, PESOS_FONTE, PESOS_AVULSOS, PESO_PRESILHA_KG, derivarIP65,
  CAIXAS_EMBALAGEM, CAIXA_BY_NOME, pesoUnitarioItem, pesoLiquidoItens, kgFmt,
};
